import {RuntimeValue} from "./RuntimeValue";
import {FormData} from "../../services/FormsRenderer";
import {RuntimeString} from "./RuntimeString";

export interface RuntimeContext {
	readonly value: RuntimeValue | null;
	
	getValueByReference(reference: string): RuntimeValue | null;
}

export class DefaultRuntimeContext implements RuntimeContext {
	constructor(
		readonly formData: FormData,
		readonly value: RuntimeValue | null,
	) {
	}
	
	getValueByReference(reference: string): RuntimeValue | null {
		const value = this.formData.findValueByName(reference);
		if (value) {
			return new RuntimeString(value);
		} else {
			return null;
		}
	}
}
